export const MAX_FILE_SIZE = 20971520; // 20mb

export const EARTH_RADIUS = 6378137;
